import type { ReactNode } from "react";

import { DEPRECATED_Loading } from "@jti/ui";

type LoadingWrapperType = {
  loading: boolean;
  children: ReactNode;
};

export const LoadingWrapper = ({ loading, children }: LoadingWrapperType) => {
  if (loading) {
    return <DEPRECATED_Loading />;
  }

  return <>{children}</>;
};
